import { render } from "./ForgetPassword.vue?vue&type=template&id=6f0b52d8&scoped=true&ts=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts"

import "./ForgetPassword.vue?vue&type=style&index=0&id=6f0b52d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0b52d8"]])

export default __exports__